import { useEffect, useRef } from "react";

const LS_KEY = "flow_draft_v1";

export function loadDraft() {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export default function useAutosaveFlow(pages, setDirty) {
  const t = useRef();

  useEffect(() => {
    if (!pages) return;
    setDirty?.(true);
    clearTimeout(t.current);
    t.current = setTimeout(() => {
      try {
        localStorage.setItem(LS_KEY, JSON.stringify({ pages, ts: Date.now() }));
      } catch {}
      setDirty?.(false);
    }, 800);
    return () => clearTimeout(t.current);
  }, [pages, setDirty]);
}
